// import { useState, useEffect } from "react";

// export function useDebounce(value, delay = 500) {
//   const [debouncedValue, setDebouncedValue] = useState(value);
// console.log(value, delay,"edfcvgbhjnkml")
//   useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedValue(value);
//     }, delay);

//     return () => clearTimeout(handler); // cleanup on change/unmount
//   }, [value, delay]);

//   return debouncedValue;
// }

import { useState, useEffect, useMemo } from "react";

export function useDebounce(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  // ✅ Memoize delay and value to prevent unnecessary effects
  const memoizedDelay = useMemo(() => delay, [delay]);
  const memoizedValue = useMemo(() => value, [value]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(memoizedValue);
    }, memoizedDelay);

    return () => {
      clearTimeout(handler);
    };
  }, [memoizedValue, memoizedDelay]);

  return useMemo(() => debouncedValue, [debouncedValue]);
}
